// Based off of these reporting_app declarations
// https://stash.americas.nwea.pvt/projects/PUP/repos/nwea-reporting_app/browse/templates/reporting_app.conf.erb
import { reportTypes } from 'resources/commonStrings';

/************* !!IMPORTANT!! ******************
If this file is changed, the team that maintains DORA needs to be notified. 
This file is RLP's source of truth for reports, but it is not theirs. 
They will need to submit a request to update the report.report table or their app will not support new reports.

Example request they've made:
https://jira.americas.nwea.pvt/browse/DR-7263

Example bugs they've experienced:
https://nwea.tpondemand.com/entity/217116-dora-not-defined-report-type
https://nwea.tpondemand.com/entity/218740-dora-spike-on-fetching-new-reports
*/
export default {
  1: {
    displayName: reportTypes.studentsWithoutReportingAttributes,
  },
  2: {
    displayName: reportTypes.potentialDuplicateProfiles,
  },
  3: {
    displayName: reportTypes.userRoles,
  },
  4: {
    displayName: reportTypes.studentsWithoutValidTestResults,
  },
  5: {
    displayName: reportTypes.instructorsWithoutClassAssignments,
  },
  7: {
    displayName: reportTypes.testEventsByStatus,
  },
  8: {
    displayName: reportTypes.studentProgress,
  },
  9: {
    displayName: reportTypes.classReport,
  },
  10: {
    displayName: reportTypes.asgClassReport,
  },
  11: {
    displayName: reportTypes.districtSummary,
  },
  12: {
    displayName: reportTypes.studentGrowthSummaryReport,
  },
  13: {
    displayName: reportTypes.classByRIT,
  },
  14: {
    displayName: reportTypes.classByGoal,
  },
  15: {
    displayName: reportTypes.desCartes,
  },
  16: {
    displayName: reportTypes.pgid,
  },
  17: {
    displayName: reportTypes.desCartesQuery,
  },
  19: {
    displayName: reportTypes.mpgStudent,
  },
  20: {
    displayName: reportTypes.mpgTeacher,
  },
  21: {
    displayName: reportTypes.mpgSubSkillPerformance,
  },
  22: {
    displayName: reportTypes.comprehensiveDataFile,
  },
  23: {
    displayName: reportTypes.classByProjectedProficiency,
  },
  25: {
    displayName: reportTypes.gradeReport,
  },
  26: {
    displayName: reportTypes.projectedProficiencySummary,
  },
  27: {
    displayName: reportTypes.profilesWithSharedIDs,
  },
  28: {
    displayName: reportTypes.gradeBreakdownReport,
  },
  29: {
    displayName: reportTypes.studentsByDistrict,
  },
  100: {
    displayName: reportTypes.studentProfile,
  },
  101: {
    displayName: reportTypes.familyReport,
  },
  102: {
    displayName: reportTypes.recoveryGoalSettingReport,
  },
};
